import PageLayout from "@/components/PageLayout";
import HeroSection from "@/components/home/HeroSection";
import AppShowcaseSection from "@/components/home/AppShowcaseSection";
import StatsSection from "@/components/home/StatsSection";
import ChallengesSection from "@/components/home/ChallengesSection";
import SolutionsSection from "@/components/home/SolutionsSection";
import KeyFeaturesSection from "@/components/home/KeyFeaturesSection";
import HowItWorksSection from "@/components/home/HowItWorksSection";
import UserRolesSection from "@/components/home/UserRolesSection";
import TestimonialsSection from "@/components/home/TestimonialsSection";
import ComparisonSection from "@/components/home/ComparisonSection";
import FAQSection from "@/components/home/FAQSection";
import PaymentSection from "@/components/home/PaymentSection";
import CTASection from "@/components/CTASection";

// ─── JSON-LD Structured Data (Schema.org) ─────────────────────────────────────
const homeSchema = JSON.stringify([
  {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "@id": "https://eschool.et/",
    "url": "https://eschool.et/",
    "name": "eSchool – Student, Classroom & Fee Management System in Addis Ababa, Ethiopia",
    "isPartOf": { "@id": "https://eschool.et/#website" },
    "about": { "@id": "https://eschool.et/#organization" },
    "description": "eSchool is a powerful education management software in Addis Ababa, Ethiopia, offering smart solutions for student management, classroom control, teacher tracking, and fee management.",
    "breadcrumb": { "@id": "https://eschool.et/#breadcrumb" },
    "inLanguage": "en-ET"
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "@id": "https://eschool.et/#breadcrumb",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://eschool.et/"
      }
    ]
  },
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": "https://eschool.et/#website",
    "url": "https://eschool.et/",
    "name": "eSchool",
    "description": "Ethiopia's #1 cloud-based school management system.",
    "publisher": { "@id": "https://eschool.et/#organization" },
    "inLanguage": "en-ET"
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": "https://eschool.et/#organization",
    "name": "eSchool",
    "url": "https://eschool.et/",
    "logo": {
      "@type": "ImageObject",
      "inLanguage": "en-ET",
      "@id": "https://eschool.et/#/schema/logo/image/",
      "url": "https://eschool.et/favicon_io/android-chrome-512x512.png",
      "contentUrl": "https://eschool.et/favicon_io/android-chrome-512x512.png",
      "caption": "eSchool"
    },
    "image": { "@id": "https://eschool.et/#/schema/logo/image/" },
    "sameAs": [
      "https://facebook.com/dreamtechplc",
      "https://x.com/dreamtechplc",
      "https://tiktok.com/@dreamtech.et"
    ]
  }
]);

const Index = () => (
  <PageLayout
    title="eSchool — #1 School Management System in Ethiopia"
    description="eSchool is Ethiopia's most trusted school software. Manage attendance, fees, and results in one powerful, easy-to-use platform."
  >
    {/* Inline JSON-LD structured data */}
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: homeSchema }}
    />

    <HeroSection />
    <StatsSection />
    <ChallengesSection />
    <SolutionsSection />
    <KeyFeaturesSection />
    <PaymentSection />
    <AppShowcaseSection />
    <UserRolesSection />
    <HowItWorksSection />
    <TestimonialsSection />
    <ComparisonSection />
    <FAQSection />
    <CTASection />
  </PageLayout>
);

export default Index;
